import { useEffect } from 'react';

// Module-level (not per-component) so concurrently-mounted dialogs share one lock.
// Ref-counted: the overflow value is captured only on the 0→1 transition and
// restored only on the 1→0 transition, so whichever dialog closes last is the one
// that puts the background scroll state back — regardless of open/close order.
let lockCount = 0;
let previousOverflow = '';

/**
 * Locks scroll on this app's `.App` scroll container (not `document.body` — the
 * usual body-overflow trick is a no-op here) while `active` is true. Safe to use
 * from multiple dialogs mounted at once.
 */
export function useAppScrollLock(active: boolean): void {
  useEffect(() => {
    if (!active) return;
    const scrollContainer = document.querySelector('.App') as HTMLElement | null;
    if (!scrollContainer) return;

    if (lockCount === 0) {
      previousOverflow = scrollContainer.style.overflow;
    }
    lockCount += 1;
    scrollContainer.style.overflow = 'hidden';

    return () => {
      lockCount = Math.max(0, lockCount - 1);
      if (lockCount === 0) {
        scrollContainer.style.overflow = previousOverflow;
      }
    };
  }, [active]);
}
